import { MdButton, MdEmptyState, MdField, MdIcon, MdList } from 'vue-material/dist/components'
import { PluginFunction, PluginObject } from 'vue'

let plugins: Array<PluginObject<any> | PluginFunction<any>> = [MdButton, MdEmptyState, MdField, MdIcon, MdList]

export default plugins
